import { render, staticRenderFns } from "./RetrogradeTable.vue?vue&type=template&id=080b5abd&scoped=true&"
import script from "./RetrogradeTable.vue?vue&type=script&lang=js&"
export * from "./RetrogradeTable.vue?vue&type=script&lang=js&"
import style0 from "./RetrogradeTable.vue?vue&type=style&index=0&id=080b5abd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080b5abd",
  null
  
)

export default component.exports